<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Robot Family Metadata: {{ metadata.robot_family }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <h5 class="text-uppercase" i18n>Robot Family Metadata Details</h5>
    <dl class="row small">
      <dt class="col-4" i18n>Robot Family</dt>
      <dd *ngIf="metadata.robot_family !== null; else noUser" class="col-8">
        {{ metadata.robot_family }}
      </dd>
    </dl>
    <dl class="row small">
      <dt class="col-4" i18n>Metadata Type</dt>
      <dd *ngIf="metadata.metadata_type !== null; else noUser" class="col-8">
        {{ metadata.metadata_type }}
      </dd>
    </dl>
    <dl class="row small">
      <dt class="col-4" i18n>Created By</dt>
      <dd *ngIf="metadata.created_by !== null; else noUser" class="col-8">
        {{ metadata.created_by }}
      </dd>
    </dl>
    <dl class="row small">
      <dt class="col-4" i18n>Created On</dt>
      <dd class="col-8">{{ formatted_created_time }}</dd>
    </dl>
    <dl class="row small">
      <dt class="col-4" i18n>Last Updated By</dt>
      <dd *ngIf="metadata.last_updated_by !== null; else noUser" class="col-8">
        {{ metadata.last_updated_by }}
      </dd>
    </dl>
    <dl class="row small">
      <dt class="col-4" i18n>Last Updated On</dt>
      <dd class="col-8">{{ formatted_updated_date }}</dd>
    </dl>
    <ng-template #noUser>
      <dd class="col-8" i18n>Unknown</dd>
    </ng-template>

    <hr />
    <h6 class="text-uppercase" i18n>Metadata</h6>
    <table style="width: 100%">
      <tr>
        <th i18n>Extent Type</th>
        <th i18n>Minimum Confidence</th>
        <th i18n>Priority</th>
      </tr>
      <tr *ngFor="let item of metadata.metadata">
        <td>{{ item.extent_type }}</td>
        <td>{{ item.confidence }}</td>
        <td>{{ item.priority }}</td>
      </tr>
    </table>
  </nb-card-body>
</nb-card>
